import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Form from './../../Form';
import CheckboxMultiSelect from './../../CheckboxMultiSelect';
import Loading from './../../Loading';
import config from '../../../config';
import { getTranslationFor } from 'src/locale/lang';


class BogSettingsForm extends Form{
    static propTypes = {
        onBogSettingsGetRequest: PropTypes.func,
        countries: ImmutablePropTypes.map
    };

    constructor(props, context) {
        super(props, context);
    }

    static fieldsValidation = {
        maxPayout: [ 'required', 'decimal',(value, data) => {
            let val = parseFloat(value);
            if ( !isNaN(val) && val < 1){
                return getTranslationFor('ERROR_DECIMAL');
            } else {
                return null;
            }
        } ]
    };

    componentDidMount() {
        this.props.onBogSettingsGetRequest();
    }

    UNSAFE_componentWillReceiveProps(props) {
        if (props.data !== this.props.data && status !== 'IN_PROGRESS') {
            this.setState({
                data: props.data
            });
        }

        Form.prototype.UNSAFE_componentWillReceiveProps.apply(this, arguments);
    }

    onSubmit(e) {
        e.preventDefault();

        let { data } = this.state;

        Form.prototype.onSubmit.call(this, e);

        this.props.onBogSettingsPutRequest( data );
    }

    renderForm() {

        let listTerritories = {},
            listEligibleBetTypes = {};
        config.countries
            .filter(item => item.id !== '')
            .map( item => {
                listTerritories[item.id] = item.name;
        });

        config.eligibleBetTypes.map( item => {
            listEligibleBetTypes[item.id] = item.name;
        });

        return (

            <div>
                <Loading active={ this.props.status === 'IN_PROGRESS' } message="Loading BOG settings ..." />
                <div className="row">
                    <div className="col-4">
                        {
                            this.getCheckbox(
                                'bpEnabled',
                                'Global BOG'
                            )
                        }
                        {
                            this.getField(
                                <input
                                    type="text"
                                    label="BOG max payout"
                                    { ...this.getFieldParameters('maxPayout') }
                                />
                            )
                        }
                        {
                            this.getField(
                                <CheckboxMultiSelect
                                    placeholder="Territories"
                                    list={ listTerritories }
                                    { ...this.getFieldParameters('countries') }
                                />
                            )
                        }
                        {
                            this.getField(
                                <CheckboxMultiSelect
                                    placeholder="Bet types"
                                    list={ listEligibleBetTypes }
                                    { ...this.getFieldParameters('eligibleBetTypes') }
                                />
                            )
                        }
                        <div className="buttons">
                            <button className="btn btn-primary" type="submit">
                                Change Bog Settings
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default BogSettingsForm;
